<template>
  <div class="supplier-map">
    <div id="supplier-map-view"></div>

    <div class="supplier-list">
      <div class="list-view" v-for="(item, index) in lists" :key="index">
        <div class="list-label" :style="{ backgroundImage: 'url(' + labelBg + ')' }">{{index + 1}}</div>
        <div class="comp-view">
          <p>昃奇科技有限公司</p>
          <p>浙江省杭州市拱墅区龙游路56号</p>
        </div>
        <comp-icon class="comp-logo" src="" :width="64" :height="64"></comp-icon>
      </div>
    </div>
  </div>
</template>

<script>
import {DomainService} from '@/libs'
import { JsLoad } from '@/utils/utils'
import CompIcon from '@/components/icon/comp-icon.vue';

let BMapGL = null;
let mapObj = null;

export default {
  data(){
    return {
      lists: [
        { name: '企业', desc: '简介', latlng: '120.306715,30.395922' },
        { name: '企业', desc: '简介', latlng: '120.300939,30.395915' },
        { name: '企业', desc: '简介', latlng: '120.302071,30.397597' },
        { name: '企业', desc: '简介', latlng: '120.303859,30.392714' },
        { name: '企业', desc: '简介', latlng: '120.309222,30.396265' },
        { name: '企业', desc: '简介', latlng: '120.294777,30.393127' },
        { name: '企业', desc: '简介', latlng: '120.29113,30.399902' },
        { name: '企业', desc: '简介', latlng: '120.296322,30.394824' },
        { name: '企业', desc: '简介', latlng: '120.313102,30.393672' },
      ],
      labelBg: `${DomainService.PublicPath}resource/images/icon/posmarket.png`,
    }
  },
  components: { CompIcon },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      window.HOST_TYPE = "2";
      window.BMap_loadScriptTime = (new Date).getTime();

      BMapGL = await JsLoad('BMapGL', 'https://api.map.baidu.com/getscript?type=webgl&v=2.0&ak=W6WIQmkWMM7fHZ1bQzONDGwimUikfaPU&services=&t=20220113143013');
      
      // 百度地图API功能
      mapObj = new BMapGL.Map('supplier-map-view');
      mapObj.centerAndZoom(new BMapGL.Point(120.304568, 30.395953), 15);
      mapObj.enableScrollWheelZoom(true);

      // 创建点标记
      this.lists.forEach((item, index) => {
        const [lng, lat] = item.latlng.split(',');
        mapObj.addOverlay(this.getMarketIcon(lng, lat, index));
        if (index <= 5) {
          mapObj.addOverlay(this.getMarketLabel(lng, lat, `${index + 1}`));
        }
      })
    },

    // 获取覆盖物对象
    getMarketIcon(lng, lat, index) {
      var pt = new BMapGL.Point(lng, lat);
      const mainIcon = new BMapGL.Icon(`${location.origin}${DomainService.PublicPath}resource/images/icon/posmarket.png`, new BMapGL.Size(19, 29));
      const miniIcon = new BMapGL.Icon('data:image/gif;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAHElEQVQI12P4//8/w38GIAXDIBKE0DHxgljNBAAO9TXL0Y4OHwAAAABJRU5ErkJggg==', new BMapGL.Size(8, 8));
      const marker = new BMapGL.Marker(pt, {
        icon: index <= 5 ? mainIcon : miniIcon
      });
      marker.addEventListener("click", () => {
        mapObj.openInfoWindow(this.dialogInfo('sdasdasd'), pt); //开启信息窗口
      });
      return marker;
    },

    // 获取文字覆盖对象
    getMarketLabel(lng, lat, text) {
      const pt = new BMapGL.Point(lng, lat);
      const opts = {
        position: pt,
        offset: new BMapGL.Size(-9.5, -14.5) // 设置文本偏移量
      };
      const label = new BMapGL.Label(text, opts);
      // 自定义文本标注样式
      label.setStyle({
          width: '19px',
          color: '#ffffff',
          fontSize: '14px',
          height: '19px',
          lineHeight: '19px',
          border: '0 none',
          background: 'transparent',
          textAlign: 'center',
      });
      return label;
    },

    // 获取信息窗口对象 
    dialogInfo(content = '') {
      var opts = {
          width : 160,     // 信息窗口宽度
          height: 50,     // 信息窗口高度
      }
      return new BMapGL.InfoWindow(content, opts);
    }
  }
}
</script>

<style scoped lang="less">
.supplier-map{
  width: 100%;
  height: 100%;
  max-height: 100vh;
  position: relative;
}
#supplier-map-view{
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
}
.supplier-list{
  width: 360px;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 2;
  background: #ffffff;
  overflow-y: auto;
  padding-top: 20px;
  .comp-logo{
    width: 64px;
    height: 64px;
    border: 2px solid #F8F9FC;
    position: absolute;
    right: 0;
    top: 0;
  }
  .list-view{
    height: 64px;
    position: relative;
    padding-left: 33px;
    padding-right: 76px;
    margin: 0 18px 20px 18px;
    cursor: pointer;
  }
  p{
    margin: 0;
  }
  .list-label{
    width: 19px;
    height: 29px;
    position: absolute;
    left: 0;
    top: 17px;
    line-height: 19px;
    color: #ffffff;
    text-align: center;
    font-size: 14px;
    background-size: 100% 100%;
  }
  .comp-view{
    p{
      line-height: 32px;
      color: #999999;
      font-size: 14px;
    }
    p:first-child{
      color: #000;
      font-size: 16px;
    }
  }
}
</style>
